export default "__VITE_ASSET__VSgh9dHq__"